import { mapActions, mapGetters } from 'vuex'

export default {

  data () {
    return {
      color: '#ffffff',
      panel: undefined
    }
  },

  /* eslint-disable */
  computed: {
    ...mapGetters ({
      'messages': 'notificationStore/messages',
      'show': 'notificationStore/show'
    }),
    msgShow () {
      return this.show
    },
    msgColor () {
      return this.messages.length > 0 ? this.messages[0].color : '#ffffff'
    },
    msgText () {
      return this.messages.length > 0 ? this.messages[0].text : ''
    },
    msgDetails () {
      return this.messages.length > 0 ? this.messages[0].details : ''
    },
    msgId () {
      return this.messages.length > 0 ? this.messages[0].id : ''
    },
    showClose () {
      return this.messages.length > 0 ? !this.messages[0].hideClose : false
    }
  },

  methods: {
    ...mapActions ({
      '_removeMessage': 'notificationStore/removeMessage'
    }),


    removeMessage () {
      this._removeMessage()
      this.panel = undefined
    },

    onClick() {
      /*this will toggle only by icon click. at the same time, will prevent toggle 
      by clicking on header. */

      const curr = this.panel
      this.panel = curr === undefined ? 0 : undefined
    }
  }
}
